import { render } from "./FamilyEventWrapperView.vue?vue&type=template&id=52bd1f32&ts=true"
import script from "./FamilyEventWrapperView.vue?vue&type=script&lang=ts"
export * from "./FamilyEventWrapperView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__